<template>
  <section class="bg-light">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 col-12 p-0 text-small">
        <section class="px-2" v-if="jobUser">
          <!-- Profile -->
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="mb-3">
                  <img :src="jobUser.picture" alt="" class="rounded-circle" width="64">
                </div>
                <div class="pl-3">
                  <ul class="list-unstyled">
                    <li><h3 class="m-0" v-html="getUserType(jobUser)"></h3></li>
                    <li>
                      <h3 class="m-0 py-2">
                        <span v-if="jobUser.prefix_name">{{ jobUser.prefix_name }}</span>
                        {{ jobUser.name }}
                        <span v-if="jobUser.birth_date">{{ getUserAge() }} ปี</span>
                      </h3>
                    </li>
                    <li class="text-small text-secondary">
                      <span class="d-inline-block pr-2" v-if="jobUser.tel">
                        <i class="fas fa-phone text-primary"></i> {{ jobUser.tel }}
                      </span>
                      <span class="d-inline-block pr-2" v-if="jobUser.address_province && jobUser.district">
                        <i class="fas fa-map-marker-alt -status-alert"></i> {{ jobUser.address_province.name_th }} - {{ jobUser.district.name_th }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <hr>

              <div class="d-flex">
                <div class="flex-fill">
                  <p><b>แนะนำตัว</b>:<br> <span> {{ jobUser.introduce }} </span></p>
                </div>
              </div>

              <div class="d-flex">
                <div class="flex-fill">
                  <p><b>ประสบการณ์ทำงาน</b>:<br> <span> {{ jobUser.working_experience }} </span></p>
                </div>
              </div>

              <div class="d-flex">
                <div class="flex-fill">
                  <p><b>สถานภาพ</b>: <span> {{ jobUser.marital_status }} </span></p>
                </div>
              </div>


              <div class="d-flex">
                <div class="flex-fill">
                  <p><b>ทักษะขับรถยนต์</b>: <span> {{ jobUser.driving_car }} </span></p>
                </div>
              </div>

              <div class="d-flex">
                <div class="flex-fill">
                  <p><b>ทักษะขับมอเตอร์ไซค์</b>: <span> {{ jobUser.driving_motorcycle }} </span></p>
                </div>
              </div>

              <div class="d-flex">
                <div class="flex-fill">
                  <p><b>โรคประจำตัว</b>: <span> {{ jobUser.disease }} </span></p>
                </div>
              </div>


              <div class="d-flex">
                <div class="flex-fill">
                  <h3 class="mb-2">ทักษะของฉัน</h3>
                  <ul class="pl-3" style="line-height: 1.75rem;">
                    <template v-for="(jobSkill, index) in jobSkills">
                      <li v-if="hasSkill(jobSkill.id)" :key="index">{{ jobSkill.name }}</li>
                    </template>
                  </ul>
                </div>
                <div class="flex-fill">
                  <h3 class="mb-2">ภาษาที่ฉันสื่อสารได้</h3>
                  <ul class="pl-3" style="line-height: 1.75rem;">
                    <template v-for="(jobLanguage, index) in jobLanguages">
                      <li v-if="hasLanguage(jobLanguage.id)" :key="index">
                        {{ (jobLanguage.name === 'Thai') ? jobLanguage.native : jobLanguage.name }}
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
              <div>
                <button class="btn btn-block btn-outline-info" @click="showModal()">แก้ไขข้อมูล</button>
              </div>
            </div>
          </div>

          <div class="card shadow-sm">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-fill">
                  <label class="m-0">ให้ระบบแจ้งเตือนงานที่ตรงกับคุณสมบัติของฉันไปที่ Line</label>
                </div>
                <div>
                  <toggle-button :value="(jobUser.allow_notification===1)"
                                 @change="updateAllowNotification"
                                 color="#FFC107"/>
                </div>
              </div>
            </div>
          </div>

          <div class="pb-4">
            <button class="btn btn-block btn-lg btn-light bg-white border shadow-sm" @click="logout()">
              <span class="text-secondary text-small"><i class="fas fa-sign-out-alt"></i> ออกจากระบบ</span>
            </button>
          </div>
        </section>

        <section class="px-2" v-else>
          <div class="card">
            <div class="card-body">
              <h2 class="text-center">มีบัญชีกับ BeNeat Jobs หรือยัง?</h2>
              <div class="text-center">
                <a :href="apiUrl"
                   class="btn btn-success btn-lg"
                   v-if="apiUrl">
                  <span class="d-inline-block pl-2">
                    <i class="fab fa-line fa-lg"></i>
                  </span>&nbsp;&nbsp;ล็อคอิน/ลงทะเบียน BeNeat Jobs ผ่าน LINE
                </a>

                <div class="pt-3 text-left" v-if="isDevelopment()">
                  <hr>
                  <div class="form-group">
                    <label for="lineId">Line User Id (for testing)</label>
                    <input type="text" class="form-control" id="lineId" v-model="lineUserId">
                  </div>
                  <button class="btn btn-info btn-block" @click="testLoginJobUser()">
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <update-profile-modal ref="updateProfileModal"></update-profile-modal>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UpdateProfileModal from './UpdateProfileModal'
import { jobPostMixin } from '../../mixins/jobPostMixin'

export default {
  mixins: [jobPostMixin],
  components: {
    UpdateProfileModal
  },
  data () {
    return {
      userType: null,
      apiUrl: null,
      response: null,
      lineUserId: null
    }
  },
  computed: {
    ...mapState('jobUser', ['jobUser', 'jobSkills', 'jobLanguages'])
  },
  methods: {
    ...mapActions('jobUser', ['loginLineJobUser', 'loginJobUser', 'fetchJobUserDetail', 'updateJobUser']),
    async updateAllowNotification () {
      if (this.jobUser) {
        this.jobUser.allow_notification = (this.jobUser.allow_notification === 1) ? 0 : 1
        const submitData = {
          id: this.jobUser.id,
          allow_notification: this.jobUser.allow_notification
        }
        await this.updateJobUser(submitData)
      }
    },
    getUserType (jobUser) {
      let userType = '<span class="badge badge-dark">ผู้ใช้ทั่วไป</span>'
      if (jobUser.professional_id) {
        userType = '<span class="badge badge-info">แม่บ้าน BeNeat</span>'
      } else if (jobUser.professional_register_id) {
        userType = '<span class="badge badge-success">ผู้สมัครแม่บ้าน BeNeat</span>'
      }
      return userType
    },
    getUserAge () {
      let result = null
      if (this.jobUser) {
        const arr = this.jobUser.birth_date.split('-')
        const ageDifMs = Date.now() - new Date(arr[0], arr[1], arr[2]).getTime()
        const ageDate = new Date(ageDifMs) // miliseconds from epoch
        result = Math.abs(ageDate.getFullYear() - 1970)
      }
      return result
    },
    async checkLineCallBack () {
      const queryParams = this.$route.query
      if (queryParams && queryParams.callback) {
        const submitData = {
          code: queryParams.code
        }
        await this.loginLineJobUser(submitData)
        if (this.jobUser) {
          await this.fetchJobUserDetail(this.jobUser.id)
          this.$router.push(this.$route.path)
          this.validateJobUserInfo()
        }
      }
    },
    async testLoginJobUser () {
      if (this.lineUserId) {
        const submitData = {
          line_user_id: this.lineUserId
        }
        await this.loginJobUser(submitData)
        if (this.jobUser) {
          await this.fetchJobUserDetail(this.jobUser.id)
        }
      }
    },
    showModal () {
      this.$refs.updateProfileModal.displayModal(true)
    },
    logout () {
      this.$swal({
        title: this.$i18n.t('message.confirm.title'),
        text: this.$i18n.t('message.confirm.confirm_logout'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#9E9E9E',
        reverseButtons: true,
        confirmButtonText: this.$i18n.t('message.confirm.yes'),
        cancelButtonText: this.$i18n.t('message.confirm.no')
      }).then(() => {
        this.$store.commit('jobUser/SET_JOB_USER', null)
      })
    },
    validateJobUserInfo () {
      let valid = true
      if (!this.jobUser.prefix_name) valid = false
      if (!this.jobUser.name) valid = false
      if (!this.jobUser.tel) valid = false
      if (!this.jobUser.birth_date) valid = false
      if (!this.jobUser.address_province_id) valid = false
      if (!this.jobUser.district_id) valid = false
      if (!valid) {
        this.$refs.updateProfileModal.displayModal(true)
      }
    },
    hasSkill (jobSkillId) {
      let result = false
      for (const jobUserJobSkill of this.jobUser.job_user_job_skills) {
        if (jobUserJobSkill.job_skill_id === jobSkillId) {
          result = true
          break
        }
      }
      return result
    },
    hasLanguage (languageId) {
      let result = false
      for (const jobUserLanguage of this.jobUser.job_user_languages) {
        if (jobUserLanguage.language_id === languageId) {
          result = true
          break
        }
      }
      return result
    },
    isDevelopment () {
      let result = false
      if (window.location.hostname === 'localhost' || window.location.hostname === 'dev.beneat.co' || window.location.hostname === 'customer.beneat-test.com') {
        result = true
      }
      return result
    }
  },
  async mounted () {
    if (this.jobUser && this.jobUser.id) {
      await this.fetchJobUserDetail(this.jobUser.id)
    } else {
      this.$store.commit('jobUser/SET_JOB_USER', null)
    }
    this.checkLineCallBack()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jobPost/JobUser.vue